var newsletterSubmit = {
  emailInput: $('#newsletter_request_email'),
  submitButton: $('#newsletter_request_submit'),

  init: function () {
    this.form = this.emailInput.closest('form');
    toastr.options.positionClass = 'toast-bottom-center';

    var app = this;
    this.emailInput.keypress(function (e) {
      if (e.which === 13) {
        $('.error-messages').remove();
        if (app.form[0].checkValidity()) {
          event.preventDefault();
          $('.error-messages').remove();
          app.submitForm(app.form.serialize());
        } else {
          app.submitButton.click();
        }
      }
    });
    this.submitButton.on('click', function (event) {
      $('.error-messages').remove();
      if (app.form[0].checkValidity()) {
        event.preventDefault();
        $('.error-messages').remove();
        app.submitForm(app.form.serialize());
      }
    });
  },
  submitForm: function (serializedForm) {
    var app = this;
    $.ajax({
      url: this.form.attr('action'),
      method: 'POST',
      data: serializedForm,
      beforeSend: function () {
        app.disableButton(true);
      },
      success: function (response) {
        if (response.ok || response.isOk) {
          app.showMessage(response.message, 'success');
        } else {
          app.showMessage(response.message, 'warning');
        }
      },
      error: function (response) {
        app.showMessage(response.responseJSON.message, 'error');
      },
      complete: function (jqXHR, status) {
        app.enableButton();
        app.form[0].reset();
      },
    });
  },
  showMessage: function (message, type) {
    toastr[type](message);
  },
  disableButton: function () {
    this.submitButton.attr('disabled', 'disabled');
  },
  enableButton: function () {
    this.submitButton.attr('disabled', false);
  },
};

$(function () {
  newsletterSubmit.init();
});
